<template>
  <div id="profilContainer"></div>
</template>

<script>
import * as Highcharts from "highcharts/highcharts.js";
import * as turf from "@turf/turf";
import * as Annotations from "highcharts/modules/annotations";
// Initialize exporting module.
Annotations(Highcharts);
export default {
  components: {},
  props: ["coureur", "lines"],
  data() {
    return {
      profil_chart: {},
      elevation_profil: [],
      min_elevation: 0,
    };
  },
  watch: {
    coureur: function (newVal, oldVal) {
      // watch it
      this.profil_chart.removeAnnotation("pos");
      this.displayCoureur();
    },
  },
  methods: {
    getPointPosition: function (distance) {
      if (distance <= 0) {
        return this.elevation_profil[0].data[0];
      }
      var best_position = [];
      for (var i = 0; i < this.elevation_profil[0].data.length; i++) {
        if (distance > this.elevation_profil[0].data[i][0]) {
          best_position = this.elevation_profil[0].data[i];
        } else {
          break;
        }
      }
      return best_position;
    },
    findClosestPositionOnProfil: function () {
      var closest_point = [];
      var closest_distance = 100000;
      for (var i = 0; i < this.lines.length; i++) {
        if (this.coureur.estimation.position) {
          var from = turf.point([this.coureur.estimation.position[1], this.coureur.estimation.position[0]]);
        } else {
          var from = turf.point([this.coureur.position[1], this.coureur.position[0]]);
        }
        var to = turf.point(this.lines[i]);
        var options = {
          units: "kilometers",
        };
        var d = turf.distance(from, to, options);
        if (d < closest_distance) {
          closest_distance = d;
          closest_point = this.lines[i];
        }
      }
      var closest_point_distance_along = this.getDistanceAlongGPX(closest_point);
      return this.getPointPosition(closest_point_distance_along);
    },
    getDistanceAlongGPX: function (p) {
      var distance = 0;
      for (var i = 0; i < this.lines.length; i++) {
        if (this.lines[i] === p) {
          return distance;
        } else {
          if (i > 0) {
            var before = i - 1;
            var from = turf.point(this.lines[before]);
            var to = turf.point(this.lines[i]);
            var options = {
              units: "kilometers",
            };
            distance = turf.distance(from, to, options) + distance;
            distance = parseFloat(distance.toFixed(3));
          }
        }
      }
      return distance;
    },

    displayCoureur: function () {
      var coureur_position;
      if (!this.coureur.statut.pris_depart || !this.coureur.statut_course.start) {
        coureur_position = this.elevation_profil[0].data[0];
      } else if (this.coureur.statut.arrivee || this.coureur.statut_course.end) {
        coureur_position = this.getPointPosition(this.coureur.parcours.nb_km);
      } else {
        if (!this.coureur.estimation) return;
        if (this.coureur.estimation.trackingMethod === "estimation") {

          coureur_position = this.getPointPosition(this.coureur.estimation.distance);

        } else {
          coureur_position = this.findClosestPositionOnProfil();
        }
      }
      var annotation = {
        draggable: "",
        id: "pos",
        labelOptions: {
          borderRadius: 0,
          borderColor: "transparent",
          verticalAlign: "bottom",
          y: -37,
          x: 8,
        },
        labels: [
          {
            shape: "circle",
            point: {
              xAxis: 0,
              yAxis: 0,
              x: coureur_position[0],
              y: coureur_position[1],
            },
            useHTML: true,
            text:
              "<div class='pin_runner_profil_container'><img class='pin_runner_profil' src='https://sportips.fr/live/includes/img/pin-runner-2.png'/><span class='pin_runner_content'>" +
              this.coureur.identite.nom.charAt(0).toUpperCase() +
              this.coureur.identite.prenom.charAt(0).toUpperCase() +
              "</span></div>",
            color: "red",
            backgroundColor: "transparent",
          },
        ],
      };

      this.profil_chart.addAnnotation(annotation);
    },

    displayPoints: function () {
      for (var i = 1; i < this.coureur.passages.list.length - 1; i++) {
        var point = this.coureur.passages.list[i];
        var point_position = this.getPointPosition(point.distance_depuis_depart);

        let plotLine = {
          color: "#2f3a45",
          width: 1,
          value: point_position[0],
          id: point.nom_affiche,
          label: {
            useHTML: true,
            text: "<div style='background-color:#2f3a45;color:white;padding: 3px 10px;border-radius:5px;'>" + point.nom_affiche + "</div>",
            rotation: 0,
            align: "center",
            style: {
              color: "#2f3a45",
            },
          },
        };
        this.profil_chart.xAxis[0].addPlotLine(plotLine);
      }
    },

    setUpProfil: function () {
      this.buildElevationProfilDatas();

      var _this = this;
      this.profil_chart = Highcharts.chart("profilContainer", {
        chart: {
          height: 200,
          type: "area",
          zoomType: "x",
          panning: true,
          panKey: "shift",
          backgroundColor: "#e9f1f3",
          scrollablePlotArea: {
            minWidth: 600,
          },
        },
        title: {
          text: null,
        },
        xAxis: {
          labels: {
            format: "{value} km",
            style: {
              color: "#2f3a45",
            },
          },
          title: {
            text: null,
          },
        },
        yAxis: {
          min: _this.min_elevation,
          startOnTick: false,
          endOnTick: false,
          maxPadding: 0.35,
          gridLineColor: "rgba(47, 58, 69, 0.2)",
          title: {
            text: null,
          },
          labels: {
            format: "{value} m",
            style: {
              color: "#2f3a45",
            },
          },
        },
        tooltip: {
          enabled: false,
          followTouchMove: false,
          followPointer: false,
        },

        legend: {
          enabled: false,
        },

        series: _this.elevation_profil,
        plotOptions: {
          series: {
            point: {
              events: {
                mouseOver: function (p) {
                  _this.$emit("focus_point", p.target.x);
                },
              },
            },
            events: {
              mouseOut: function () {
                _this.$emit("focus_point", 0);
              },
            },
          },
        },
      });
      this.displayPoints();
      this.displayCoureur();
    },

    getPlotLines: function () {
      let plotlines = [];
      for (var i = 1; i < this.coureur.points.length - 1; i++) {
        var point = this.coureur.points[i];
        var point_position = this.getPointPosition(point.distance_depuis_depart);

        let plotLine = {
          color: "#2f3a45",
          width: 1,
          value: point_position[0],
          id: point.nom_affiche,
          label: {
            useHTML: true,
            text: "<div style='background-color:#2f3a45;color:white;padding: 3px 10px;border-radius:5px;'>" + point.nom_affiche + "</div>",
            rotation: 0,
            align: "center",
            style: {
              color: "#2f3a45",
            },
          },
        };
        plotlines.push(plotLine);
        return plotlines;
      }
    },

    buildElevationProfilDatas: function () {
      var declinaison_elevation_datas = [[]];

      var last_elevation = 0;
      for (var i = 0; i < this.lines.length; i++) {
        if (this.lines[i][2]) {
          last_elevation = this.lines[i][2];
        }
        if (i == 0) {
          declinaison_elevation_datas[0].push([0, parseFloat(last_elevation.toFixed(1))]);

        } else {
          var before = i - 1;
          var from = turf.point(this.lines[before]);
          var to = turf.point(this.lines[i]);
          var options = {
            units: "kilometers",
          };
          var distance = turf.distance(from, to, options) + declinaison_elevation_datas[0][before][0];
          distance = parseFloat(distance);
          declinaison_elevation_datas[0].push([distance, parseInt(last_elevation.toFixed(1))]);

        }
      }
      var min_elevation = null;
      for (var j = 0; j < declinaison_elevation_datas[0].length; j++) {
        var elevation = declinaison_elevation_datas[0][j][1];
        if (min_elevation === null || elevation < min_elevation) {
          min_elevation = elevation;
        }
      }
      this.min_elevation = min_elevation;

      let series = [];
      for (var i = 0; i < declinaison_elevation_datas.length; i++) {
        let serie = {
          data: declinaison_elevation_datas[i],
          lineColor: "#f29200",
          color: "#f29200",
          fillOpacity: 0.1 * (1 / (i + 1)),
          name: "Elevation",
          marker: {
            enabled: false,
          },
          threshold: min_elevation,
        };
        series.push(serie);
      }

      this.elevation_profil = series;
    },
  },
  mounted() {
    this.setUpProfil();
  },
};
</script>

<style>
.pin_runner_profil {
  position: absolute;

  width: 30px;
}

.pin_runner_profil_container {
  font-weight: bold;
  padding: 0 2px;
  width: 50px;
}

.pin_runner_content {
  position: absolute;

  top: 8px;
  left: 10px;
}
</style>
